import { LitElement, html } from 'lit';
import fsTypography from '@cof/fs-typography-core/lib/typography.lit.min.js';
import { TagKey } from '@cof/tag-catalog-fs-offers-mfe';
import { style } from './approved-apr.style.js';
import { DebugService } from '../../shared/services/debug.service.js';
import { AppService } from '../../app.service.js';
import { OffersService } from '../offers.service.js';
import { stratum } from '../../../constants/stratum.js';

class RefiApprovedApr extends LitElement {
  constructor() {
    super();
    this.debug = new DebugService('RefiApprovedApr');
    this.expiryDate = AppService.appExpDate;
    [this.offer] = OffersService.offers;
  }

  static get styles() {
    return [style, fsTypography];
  }

  connectedCallback() {
    super.connectedCallback();
    this.displayProgressBar(false);
    stratum.publishTag(TagKey.PAGE_VIEW_COAF_REFI_OFFERS_APPROVED);
    stratum.publishTag(TagKey.APR_INTERSTITIAL_APR_INTERSTITIAL_VALUES, {
      replacements: {
        value: `APR Shown: ${this.offer.offerApr}%}`,
      },
    });
  }

  render() {
    return html`
      <refi-track-pageview pagename="interstitial"></refi-track-pageview>
      <div class="container">
        <h1 class="header">Congrats, you have offers!</h1>
        <h2 class="subheader">First, let's see your new rate</h2>
        <div class="glow"></div>
        <div class="white-container">
          <div class="shield"></div>
          <div class="rate-container">
            <div>
              <div class="fs-overline-text fs-overline-text--normal">Your Real Rate</div>
            </div>
            <div>
              <div class="apr-container">
                <span class="apr-number">${this.offer.offerApr}</span>
                <div class="apr-stack"><span class="apr-sign">%</span><span class="apr-text">APR</span></div>
              </div>
              <fs-body-text size="tiny" class="expiry">Expires ${this.expiryDate}</fs-body-text>
            </div>
            <fs-button variant="primary" type="button" class="offer-button" @click=${this.goToOffers}>See my offers</fs-button>
          </div>
        </div>
      </div>
    `;
  }

  displayProgressBar(shouldShow) {
    this.dispatchEvent(
      new CustomEvent('show-progress-bar', {
        detail: {
          displayBar: shouldShow,
        },
        composed: true,
        bubbles: true,
      }),
    );
  }

  goToOffers() {
    this.displayProgressBar(true);
    stratum.publishTag(TagKey.APR_INTERSTITIAL_SEE_MY_OFFERS);
    this.dispatchEvent(new CustomEvent('show-offers'));
  }
}

customElements.define('refi-approved-apr', RefiApprovedApr);
